/**
 * MUI Button wrapper with Nike primary styling and variant support
 * @exports NikeButton
 * @author {Cognizant Technology Solutions}
 * @flow
 */
import React from 'react';
import './styles.scss';
import { Button } from '@mui/material';

interface Props {
  color?: string;
  buttonText?: Object;
  className?: string;
  variant?: string;
  onClick?: Function;
  testid?: string;
}

/**
 * Renders the nike button UI from incoming props.
 * @param {Props} props Component props
 * @returns {ReactComponent} Rendered component
 */
export default function NikeButton(props: Props) {
  const {
    color,
    buttonText,
    variant,
    onClick,
    className,
    testid,
    ...other
  } = props;

  /**
   * Returns variant for rendering or state updates.
   * @returns {any} Computed result
   */
  const getVariant = () => {
    switch (variant) {
      case 'contained':
        return 'contained';
      case 'outlined':
        return 'outlined';
      default:
        return 'text';
    }
  };

  const classname = `btn-nike-${variant || 'default'} nikeButton ${className || ''}`;
  const buttonTheme = color || 'primary';
  return (
    <Button
      color={buttonTheme}
      variant={getVariant()}
      className={classname}
      onClick={onClick}
      data-testid={testid || buttonText}
      {...other}
    >
      <span className="MuiButton-label">{buttonText}</span>
    </Button>
  );
}
